import { Component, ElementRef, ViewChild } from '@angular/core';
import { MatButtonModule } from "@angular/material/button";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { provideNativeDateAdapter } from "@angular/material/core";
import { MatSelectModule } from '@angular/material/select';
import { InventoryService } from 'src/app/service/inventory.service';
import { NgClass } from '@angular/common';
import { FormBuilder, FormGroup, Validators,ReactiveFormsModule } from '@angular/forms';
import { NoDataComponent } from 'src/app/component/inventory/shared/no-data/no-data.component';
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { stat } from 'fs';
import { get } from 'http';
import { environment } from 'src/environments/environment';

interface Request {
  value: string;
  viewValue: string;
}

interface ServiceForwardRequest {
  value: string;
  viewValue: string;
}

interface NewForwardRequest{
  value: string;
  viewValue: string;
}

@Component({
    selector: 'app-admin-request',
    providers: [provideNativeDateAdapter()],
    imports: [NoDataComponent, InfiniteScrollModule, ReactiveFormsModule, MatButtonModule, MatDatepickerModule, MatInputModule, MatFormFieldModule, MatSelectModule, NgClass, FormsModule],
    templateUrl: './admin-request.component.html',
    styleUrls: ['./admin-request.component.css', '../styles/inventory.css']
})
export class AdminRequestComponent {
   @ViewChild('carousel') carousel!: ElementRef;
  declineReasonForm: FormGroup;
  onHoldForm: FormGroup;
  constructor(private inventoryService: InventoryService,private fb: FormBuilder, private route: ActivatedRoute) {

    this.declineReasonForm = this.fb.group({
      rejectionReason: ['', Validators.required]
    })

    this.onHoldForm = this.fb.group({
      onHoldTillDate: ['', Validators.required]
    })
   }


    //Formatted onHold  DATE
    formatOnHoldDate(date: Date): { day: number; month: number; year: number } {
      return {
        day: date.getDate(),
        month: date.getMonth() + 1,
        year: date.getFullYear(),
      };
    }

  defaultPendingRequestType: string = 'Service-Request';
  today: string;
ngOnInit() {
  this.allAdminRequest(this.defaultPendingRequestType);
  
  const now = new Date();
  this.today = now.toISOString().split('T')[0];

  this.route.queryParams.subscribe((params) => {
    const filter = params['filter'];
    console.log('URL Filter:', filter);
    
    if (filter) {
      const decodedFilter = decodeURIComponent(filter);
      console.log('Decoded Filter:', decodedFilter);
      this.handleForwardRequestType(decodedFilter);
    } else {
      // Default to Service Request only if no filter
      this.filterForwardReq('Service Request');
    }
  });
}


  selectedForwardRequestType: string = '';
  selectedForwardDropdownValue: string = ''; 
  // handleForwardRequestType(filter: string) {
  //   this.selectedForwardRequestType = filter;
  
  //   this.selectedForwardDropdownValue = filter;
  
  //   if (filter === 'Service Request') {
  //     this.filterForwardReq('Service Request');
  //   } else if (filter === 'New Inventory Request') {
  //     this.filterForwardReq('New Inventory Request');
  //   }
  // }

handleForwardRequestType(requestType: string) {
  const decodedType = decodeURIComponent(requestType);
  console.log('Decoded request type:', decodedType); 
  
  if (decodedType.includes("Service Request")) {
    this.filterForwardReq("Service Request", 1);
    this.selectedForwardDropdownValue = "Service Request";
  } 
  else if (decodedType.includes("New Inventory Request")) {
    this.filterForwardReq("New Inventory Request", 1);
    this.selectedForwardDropdownValue = "New Inventory Request";
  }
}
  
  preview: any;
  openforwardServiceSlider(index: number) {
    this.preview = this.forwardedReq[index];
    console.log( "Preview My Assigned", this.preview);
   const modal = document.getElementById('forwardServiceSliderModal');
    if (modal) {
      modal.addEventListener('shown.bs.modal', () => {
        this.resetCarousel();
      });
    } 
  }

   resetCarousel() {
    if (this.preview?.images?.length > 1 && this.carousel) {
      const carousel = new (window as any).bootstrap.Carousel(this.carousel.nativeElement);
      carousel.to(0); // Reset to first slide
    }
  }

  forwardedReq = []
  requests: Request[] = [
    { value: 'Service-Request', viewValue: 'Service Request' },
    // { value: 'New-Inventory', viewValue: 'New Inventory Request' },
    // { value: "Service Request", viewValue: "Forwarded Request" }
  ]

  serviceForward: ServiceForwardRequest[] =[
    { value: "Service Request", viewValue: "Forwarded Service Request" }
  ]

  newForwardRequest:  NewForwardRequest[] =[
    { value: "New Inventory Request", viewValue: "Forwarded New Request" }
  ]

  onRequestSelect(value: string): void {
    console.log("Selected value:", value);
    this.allAdminRequest(value)
    this.showNewForwardedReqTable = true;
    this.showNewForwardedReqTable = false;
    // this.showServiceRequestTable = true;
  }

  onForwardSelect(value: string): void{
    this.filterForwardReq(value);
  }

  currentPageNume = 1;
  currentLimit = 100;
  totalForwarded: any;
  currentRequestType: string = "";
  showForwardedReqTable: boolean = true;
  showServiceRequestTable: boolean = false;
  showNewForwardedReqTable:boolean = false;
  totalserviceForwarded: any;
  totalNewReqForwarded: any;
filterForwardReq(
  requestType: string,
  pageNum = this.currentPageNume,
  limit = this.currentLimit
) {
  this.currentRequestType = requestType;

  const getForwardReqValue: any = {
    requestType: requestType,
    pageNum: this.currentPageNume,
    limit: this.currentLimit,
  };

  this.inventoryService
    .getAllForwardedReq(getForwardReqValue)
    .subscribe((response) => {
      console.log("Forward Response", response);
      this.forwardedReq = response["data"].records;
      if (pageNum === 1) {
        this.forwardedReq = response["data"].records;
      } else {
        this.forwardedReq = [...this.forwardedReq, ...response["data"].records];
      }

      // Reset ALL visibility flags first
      this.showForwardedReqTable = false;
      this.showServiceRequestTable = false;
      this.showNewForwardedReqTable = false;
      this.showApprovedForwardedServiceReq = false;
      this.showApprovedNewForwardedReqTable = false;

      // Set the correct table visibility based on request type
      if (requestType === "Service Request") {
        this.showForwardedReqTable = true;
        this.totalserviceForwarded = response["data"].totalCounts;
        console.log('Showing Service Request table');
      }
      else if (requestType === "New Inventory Request") {
        this.showNewForwardedReqTable = true;
        this.totalNewReqForwarded = response["data"].totalCounts;
        console.log('Showing New Inventory Request table');
      }
    });
}





  forwardedSearchQuery: any;
  searchedForwardedInventory = [];
  totalForwardedSearchedInv: any;
  onSearchForwardedInventory() {
    const getForwardReqValue: any = {
      requestType: this.currentRequestType || "Service Request", 
      searchQuery: this.forwardedSearchQuery,
      pageNum: this.currentPageNume,
      limit: this.totalForwarded,
  
    };
  
    if (!this.forwardedSearchQuery || this.forwardedSearchQuery.trim() === "") {
      this.clearForwardedSearch();
    } else {
      this.inventoryService
        .getAllForwardedReq(getForwardReqValue)
        .subscribe((response) => {
          console.log("Searched Forwarded Response", response);
          this.searchedForwardedInventory = response["data"].records;
          this.forwardedReq = this.searchedForwardedInventory;
          this.totalForwardedSearchedInv = response["data"].totalCounts;
          this.totalForwarded = this.totalForwardedSearchedInv;
        });
    }
  }
  
  clearForwardedSearch() {
    this.forwardedSearchQuery = "";
    this.filterForwardReq(this.currentRequestType || "Service Request", 1, this.currentLimit);
  }
  

  newforwardedSearchQuery: any;
  searchedNewForwardedInventory = [];
  totalNewForwardedSearchedInv: any;
  onSearchNewForwardedInventory() {
    const getForwardReqValue: any = {
      requestType: this.currentRequestType || "New Inventory Request", 
      searchQuery: this.newforwardedSearchQuery,
      pageNum: this.currentPageNume,
      limit: this.totalNewReqForwarded,
    };
  
    const field: any = {
     
    };
  
    if (!this.newforwardedSearchQuery || this.newforwardedSearchQuery.trim() === "") {
      this. clearNewForwardedSearch();
    } else {
      this.inventoryService
        .getAllForwardedReq(getForwardReqValue)
        .subscribe((response) => {
          console.log("Searched Forwarded Response", response);
          this.searchedNewForwardedInventory = response["data"].records;
          this.forwardedReq = this.searchedNewForwardedInventory;
          this.totalNewForwardedSearchedInv = response["data"].totalCounts;
          this.totalNewReqForwarded = this.totalNewForwardedSearchedInv;
        });
    }
  }
  
  clearNewForwardedSearch() {
    this.newforwardedSearchQuery = "";
    this.filterForwardReq(this.currentRequestType || "New Inventory Request", 1, this.currentLimit);
  }
  onScroll() {
    // if (this.showForwardedReqTable || this.showNewForwardedReqTable || this.showServiceRequestTable) {
      const totalLoaded = this.forwardedReq.length;
  
      let totalCount = 0;
  
      if (this.currentRequestType === 'Service Request') {
        totalCount = this.totalserviceForwarded;
      } else if (this.currentRequestType === 'New Inventory Request') {
        totalCount = this.totalNewReqForwarded;
      }
  
      if (totalLoaded >= totalCount) return;
  
      this.currentPageNume++; 
  
      this.filterForwardReq(
        this.currentRequestType,
        this.currentPageNume,
        this.currentLimit
      );
    // }
  }

    onScrollServiceForwarded() {
    // if (this.showForwardedReqTable || this.showNewForwardedReqTable || this.showServiceRequestTable) {
      const totalLoaded = this.approvedForwardedServiceReq.length;
  
      let totalCount = 0;
  
      if (this.currentRequestType === 'Service Request') {
        totalCount = this.totalApprovedForwardedServiceReq;
      }
  
      if (totalLoaded >= totalCount) return;
  
      this.currentPageNume++; 
  
      this.getApprovedForwardServiceReq(
        this.currentRequestType,
        this.currentPageNume,
        this.currentLimit
      );
    // }
  }

      onScrollForwarded() {
    // if (this.showForwardedReqTable || this.showNewForwardedReqTable || this.showServiceRequestTable) {
      const totalLoaded = this.approvedNewForwardedInventory.length;
  
      let totalCount = 0;

      if (this.currentRequestType === 'New Inventory Request') {
        totalCount = this.totalApprovedNewReqForwarded;
      }
  
      if (totalLoaded >= totalCount) return;
  
      this.currentPageNume++;

      this.getApprovedForwardNewReq(
        this.currentRequestType,
        this.currentPageNume,
        this.currentLimit
      );
    // }
  }
  

   approvedForwardedServiceReq: any;
   showApprovedForwardedServiceReq: boolean = false;
   totalApprovedForwardedServiceReq: any;
   appForwarServiceReqQuery: string = '';
   totalApprovedNewReqForwarded: any;
   showApprovedNewForwardedReqTable: boolean = false;
    getApprovedForwardServiceReq(
    requestType: string,
    pageNum = this.currentPageNume,
    limit = this.currentLimit
  ) {
    this.currentRequestType = requestType;

    const getForwardReqValue: any = {
      requestType: requestType,
      pageNum: this.currentPageNume,
      limit: this.currentLimit,
      status: 'Approved',
      searchQuery: this.appForwarServiceReqQuery,
    };


    this.inventoryService
      .getAllForwardedReq(getForwardReqValue)
      .subscribe((response) => {
        console.log("Approved req", response);
        this.approvedForwardedServiceReq = response["data"].records;
        
        if (pageNum === 1) {
          this.approvedForwardedServiceReq = response["data"].records;
        } else {
          this.approvedForwardedServiceReq = [...this.approvedForwardedServiceReq, ...response["data"].records];
        }
      
          this.showApprovedForwardedServiceReq= true;
             this.showNewForwardedReqTable = false;
          this.showForwardedReqTable = false;
          this.showServiceRequestTable = false;
            this.showApprovedNewForwardedReqTable = false;
          this.totalApprovedForwardedServiceReq = response["data"].totalCounts;
        
       
         
      });


  }

  clearappForwarServiceReq() {
    this.appForwarServiceReqQuery = '';
    this.getApprovedForwardServiceReq(this.currentRequestType || "Service Request", 1, this.currentLimit);
  }


  declinedForwardedServiceReq = [];
  showDeclinedForwardedServiceReq: boolean = false;
  totalDeclinedForwardedServiceReq: any;
  declinedForwardedServiceReqQuery: string = '';
  getDeclinedForwardServiceReq(
    requestType: string,
    pageNum = this.currentPageNume,
    limit = this.currentLimit
  ) {
    this.currentRequestType = requestType;

    const getForwardReqValue: any = {
      requestType: requestType,
      pageNum: this.currentPageNume,
      limit: this.currentLimit,
      status: 'Rejected',
      searchQuery: this.declinedForwardedServiceReqQuery,
    };


    this.inventoryService
      .getAllForwardedReq(getForwardReqValue)
      .subscribe((response) => {
        console.log("Approved req", response);
        this.declinedForwardedServiceReq = response["data"].records;

        if (pageNum === 1) {
          this.declinedForwardedServiceReq = response["data"].records;
        } else {
          this.declinedForwardedServiceReq = [...this.declinedForwardedServiceReq, ...response["data"].records];
        }
      
          this.showDeclinedForwardedServiceReq = true;
          this.showApprovedForwardedServiceReq= false;
          this.showNewForwardedReqTable = false;
          this.showForwardedReqTable = false;
          this.showServiceRequestTable = false;
          this.showApprovedNewForwardedReqTable = false;
          this.totalDeclinedForwardedServiceReq = response["data"].totalCounts;
        
       
         
      });


  }

  clearDeclinedForwardedServiceReq() {
    this.declinedForwardedServiceReqQuery = '';
    this.getDeclinedForwardServiceReq(this.currentRequestType || "Service Request", 1, this.currentLimit);
  }


  declinedForwardedNewReq = [];
  showDeclinedForwardedNewReq: boolean = false;
  totalDeclinedForwardedNewReq: any;
  declinedForwardedNewReqQuery: string = '';
  getDeclinedForwardNewReq(
    requestType: string,
    pageNum = this.currentPageNume,
    limit = this.currentLimit
  ) {
    this.currentRequestType = requestType;

    const getForwardReqValue: any = {
      requestType: requestType,
      pageNum: this.currentPageNume,
      limit: this.currentLimit,
      status: 'Rejected',
      searchQuery: this.  declinedForwardedNewReqQuery,
    };


    this.inventoryService
      .getAllForwardedReq(getForwardReqValue)
      .subscribe((response) => {
        console.log("Approved req", response);
        this.declinedForwardedNewReq = response["data"].records;

        if (pageNum === 1) {
          this.declinedForwardedNewReq = response["data"].records;
        } else {
          this.declinedForwardedNewReq = [...this.declinedForwardedNewReq, ...response["data"].records];
        }

          this.showDeclinedForwardedNewReq = true;
          this.showDeclinedForwardedServiceReq = false;
          this.showApprovedForwardedServiceReq= false;
          this.showNewForwardedReqTable = false;
          this.showForwardedReqTable = false;
          this.showServiceRequestTable = false;
          this.showApprovedNewForwardedReqTable = false;
          this.totalDeclinedForwardedNewReq = response["data"].totalCounts;
        
       
         
      });


  }

  clearDeclinedForwardedNewReq() {
    this.declinedForwardedNewReqQuery = '';
    this.getDeclinedForwardNewReq(this.currentRequestType || "New Inventory Request", 1, this.currentLimit);
  }


  approvedForwardedNewReqQuery: any;
  approvedNewForwardedInventory = [];
  getApprovedForwardNewReq(
    requestType: string,
    pageNum = this.currentPageNume,
    limit = this.currentLimit
  ) {
    this.currentRequestType = requestType;

    const getForwardReqValue: any = {
      requestType: requestType,
      pageNum: this.currentPageNume,
      limit: this.currentLimit,
      status: 'Approved',
      searchQuery: this.approvedForwardedNewReqQuery,
    };

    this.inventoryService
      .getAllForwardedReq(getForwardReqValue)
      .subscribe((response) => {
        console.log("Approved req", response);
        this.approvedNewForwardedInventory = response["data"].records;
        
        if (pageNum === 1) {
          this.approvedNewForwardedInventory = response["data"].records;
        } else {
          this.approvedNewForwardedInventory = [...this.approvedNewForwardedInventory, ...response["data"].records];
        }
      
          this.showApprovedNewForwardedReqTable = true;
          this.showApprovedForwardedServiceReq= false;
          this.showNewForwardedReqTable = false;
          this.showForwardedReqTable = false;
          this.showServiceRequestTable = false;
          this.totalApprovedNewReqForwarded = response["data"].totalCounts;  
      });
    }
  
  clearApprovedForwardedNewReq() {
    this.approvedForwardedNewReqQuery = '';
    this.getApprovedForwardNewReq(this.currentRequestType || "New Inventory Request", 1, this.currentLimit);
  }

  adminRequest = []
  showNewInv: boolean = false;
  showService: boolean = false;
  allAdminRequest(requestType: string) {
    const adminValue = {
      requestType: requestType,

      // startDate: {
      //   day: 1,
      //   month: 1,
      //   year: 2021
      // },
      // endDate: {
      //   day: 1,
      //   month: 1,
      //   year: 2025
      // },
    }
    // this.showNewInv = requestType === 'New-Inventory';
    this.showService = requestType === 'Service-Request';
    this.inventoryService.getAdminRequest(adminValue).subscribe(response => {
      console.log("Forward Response", response);
      this.adminRequest = response['data'].records;
      this.totalForwarded = response['data'].totalCounts;
      this.inventoryService.updateAdminRequestCount(this.adminRequest.length);
    });
  }

  // Price Formatting
  formatCurrency(value: string | number): string {
    if (!value) return "";
    return new Intl.NumberFormat("en-IN").format(Number(value));
  }
  

  selectedRequest: any = null;
acceptRequest(requestId: any) {
  const acceptRequest = {
    action: 'Accept',
    requestId: requestId,
    requestType: 'Service-Request',
    redirectUrl: `${environment.redirectUrl}#/inventory/service-request?filter=Approved Request`,
  }

  this.inventoryService.superAdminAction(acceptRequest).subscribe(response => {
    console.log("called");
    this.showAcceptSuccess = true;

    // refresh data
    this.allAdminRequest(this.defaultPendingRequestType);
    this.filterForwardReq(this.currentRequestType || "Service Request", 1, this.currentLimit);

    setTimeout(() => {
      const modalElement = document.getElementById('acceptRequestConfirm');
       if (modalElement) {
        (window as any).$(`#acceptRequestConfirm`).modal('hide');
      }
      this.showAcceptSuccess = false;
    }, 2000);
  });
}


  acceptNewInvRequest(requestId: any) {
    const acceptRequest = {
      action: 'Accept',
      requestId: requestId,
      requestType: 'New-Inventory',
      redirectUrl: `${environment.redirectUrl}#/inventory/new-inventory-request?filter=Approved Request`,
    }
    this.inventoryService.superAdminAction(acceptRequest).subscribe(response => {
      console.log("called");
      this.showAcceptSuccess = true;
      this.allAdminRequest(this.defaultPendingRequestType);
    this.filterForwardReq(this.currentRequestType || "New Inventory Request", 1, this.currentLimit);
  
 setTimeout(() => {
      const modalElement = document.getElementById('acceptRequestConfirm');
       if (modalElement) {
        (window as any).$(`#acceptRequestConfirm`).modal('hide');
      }
      this.showAcceptSuccess = false;
    }, 2000);
  });
  }

  
  openNewAccept(){
    console.log("Clicked Here!")
    this.showAcceptSuccess = false;
     this.showRejectConfirm = false;
      this.showDeclineModal = true;
      this.declineReasonForm.reset();
    this.showNewInv = true;
    this.showService = false;
  }

  openServiceAccept(){
     this.showAcceptSuccess = false;
     this.showRejectConfirm = false;
     this.showDeclineModal = true;
    this.showNewInv = false;
    this.showService = true;
    this.declineReasonForm.reset();
  }


  showRejectConfirm : boolean = false;
  showAcceptSuccess : boolean = false;
  showDeclineModal : boolean = true;
  onDeclineRequest(requestId: any){
    const rejectValue = {
      ...this.declineReasonForm.value
    }

    const getRejectValue = {
      rejectionReason: rejectValue.rejectionReason,
      action: 'Rejected',
      requestId: requestId,
      requestType: 'Service-Request',
      redirectUrl: `${environment.redirectUrl}#/inventory/service-request?filter=Declined Request`,
    }
    this.inventoryService.superAdminAction(getRejectValue).subscribe(response => {
      console.log("called");
      this.showRejectConfirm = true;
      this.showDeclineModal = false;

      this.allAdminRequest(this.defaultPendingRequestType);
      this.filterForwardReq(this.currentRequestType || "Service Request", 1, this.currentLimit);
    })

     setTimeout(() => {
      const modalElement = document.getElementById('declineRequestConfirm');
      if (modalElement) {
        (window as any).$(`#declineRequestConfirm`).modal('hide');
      }
      this.showRejectConfirm = false; 
    }, 2000);
  }

  onDeclineNewInvRequest(requestId: any){
    const rejectValue = {
      ...this.declineReasonForm.value
    }

    const getRejectValue = {
      rejectionReason: rejectValue.rejectionReason,
      action: 'Rejected',
      requestId: requestId,
      requestType: 'New-Inventory',
      redirectUrl: `${environment.redirectUrl}#/inventory/new-inventory-request?filter=Declined Request`,
    }
    this.inventoryService.superAdminAction(getRejectValue).subscribe(response => {
      console.log("called");
      this.showRejectConfirm = true;
      this.showDeclineModal = false;
      this.allAdminRequest(this.defaultPendingRequestType);
      this.filterForwardReq(this.currentRequestType || "New Inventory Request", 1, this.currentLimit);
    })
      setTimeout(() => {
      const modalElement = document.getElementById('declineRequestConfirm');
      if (modalElement) {
        (window as any).$(`#declineRequestConfirm`).modal('hide');
      }
      this.showRejectConfirm = false; 
    }, 2000);
  }

  onHoldRequestIds: string[] = [];
  onHoldConfirm(requestId: any) {
    const onHoldValue = {
      ...this.onHoldForm.value
    };
  
    const holdDate = new Date(onHoldValue.onHoldTillDate);
    const formattedHoldDate = this.formatOnHoldDate(holdDate);
  
    const getHoldValue = {
      action: 'On Hold',
      requestId: requestId,
      requestType: 'Service-Request',
      onHoldTill: formattedHoldDate
    };
  
    this.inventoryService.superAdminAction(getHoldValue).subscribe(response => {
      this.allAdminRequest(this.defaultPendingRequestType);
      
      this.onHoldRequestIds.push(requestId);
  
      console.log("onHoldConfirm", requestId);
    });
  }
  
  onHoldNewInvConfirm(requestId: any){
    const onHoldValue = {
      ...this.onHoldForm.value
    }

    const holdDate = new Date(onHoldValue.onHoldTillDate);
    const formattedHoldDate = this.formatOnHoldDate(holdDate);

    const getHoldValue = {
      action: 'On Hold',
      requestId: requestId,
      requestType: 'New-Inventory',
      onHoldTill: formattedHoldDate
    }

    this.inventoryService.superAdminAction(getHoldValue).subscribe(response => {
    console.log("onHoldConfirm");
    });
  }



}
